// Deployment trigger: 2026-04-24

/**
 * Verifies a Cloudflare Turnstile token via our backend before allowing an
 * auth action to proceed. Throws with a user-friendly message on failure.
 */
export const verifyTurnstile = async (token: string): Promise<void> => {
  let response: Response;
  try {
    response = await fetch('/api/verify-turnstile', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });
  } catch {
    throw new Error('Could not reach the verification service. Please try again.');
  }

  let data: any = {};
  try {
    data = await response.json();
  } catch {
    /* non-JSON response */
  }

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Captcha verification failed. Please try again.');
  }
};
